import { jsxs as k, jsx as a } from "react/jsx-runtime";
import * as l from "react";
import { u as H, c as j } from "../../../../index-D7uzFyzw.js";
import { u as y, c as A, P as R } from "../../../../index-Bud8rdvZ.js";
import { u as U } from "../../../../index-BZPx6jYI.js";
import { u as q } from "../../../../index-5jQiYUd6.js";
import { c as N } from "../../../../clsx-OuTLNxxd.js";
var b = "Switch", [z, V] = A(b), [F, L] = z(b), x = l.forwardRef(
  (e, n) => {
    const {
      __scopeSwitch: t,
      name: s,
      checked: o,
      defaultChecked: u,
      required: r,
      disabled: c,
      value: h = "on",
      onCheckedChange: p,
      form: d,
      ...S
    } = e, [w, m] = l.useState(null), v = y(n, (_) => m(_)), C = l.useRef(!1), P = w ? d || !!w.closest("form") : !0, [f, I] = H({
      prop: o,
      defaultProp: u ?? !1,
      onChange: p,
      caller: b
    });
    return /* @__PURE__ */ k(F, { scope: t, checked: f, disabled: c, children: [
      /* @__PURE__ */ a(
        R.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": f,
          "aria-required": r,
          "data-state": T(f),
          "data-disabled": c ? "" : void 0,
          disabled: c,
          value: h,
          ...S,
          ref: v,
          onClick: j(e.onClick, (_) => {
            I((M) => !M), P && (C.current = _.isPropagationStopped(), C.current || _.stopPropagation());
          })
        }
      ),
      P && /* @__PURE__ */ a(
        B,
        {
          control: w,
          bubbles: !C.current,
          name: s,
          value: h,
          checked: f,
          required: r,
          disabled: c,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
x.displayName = b;
var E = "SwitchThumb", g = l.forwardRef(
  (e, n) => {
    const { __scopeSwitch: t, ...s } = e, o = L(E, t);
    return /* @__PURE__ */ a(
      R.span,
      {
        "data-state": T(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...s,
        ref: n
      }
    );
  }
);
g.displayName = E;
var O = "SwitchBubbleInput", B = l.forwardRef(
  ({
    __scopeSwitch: e,
    control: n,
    checked: t,
    bubbles: s = !0,
    ...o
  }, u) => {
    const r = l.useRef(null), c = y(r, u), h = U(t), p = q(n);
    return l.useEffect(() => {
      const d = r.current;
      if (!d) return;
      const S = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        S,
        "checked"
      ).set;
      if (h !== t && m) {
        const v = new Event("click", { bubbles: s });
        m.call(d, t), d.dispatchEvent(v);
      }
    }, [h, t, s]), /* @__PURE__ */ a(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: t,
        ...o,
        tabIndex: -1,
        ref: c,
        style: {
          ...o.style,
          ...p,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
B.displayName = O;
function T(e) {
  return e ? "checked" : "unchecked";
}
var D = x, W = g;
const i = {
  "switch-container": "_switch-container_1m7o4_29",
  "switch-full-width": "_switch-full-width_1m7o4_35",
  "switch-disabled": "_switch-disabled_1m7o4_38",
  "switch-root": "_switch-root_1m7o4_38",
  "switch-thumb": "_switch-thumb_1m7o4_47",
  "switch-label": "_switch-label_1m7o4_82",
  "switch-title": "_switch-title_1m7o4_90",
  "switch-with-description": "_switch-with-description_1m7o4_94",
  "switch-description": "_switch-description_1m7o4_97"
}, Y = ({
  id: e,
  label: n,
  onChange: t,
  description: s,
  value: o,
  defaultChecked: u,
  name: r,
  disabled: c,
  checked: h,
  isFullWidth: p
}) => /* @__PURE__ */ k(
  "div",
  {
    className: N(
      i["switch-container"],
      c && i["switch-disabled"],
      p && i["switch-full-width"]
    ),
    children: [
      /* @__PURE__ */ k("label", { className: i["switch-label"], htmlFor: e, children: [
        /* @__PURE__ */ a("span", { className: N(i["switch-title"], s && i["switch-with-description"]), children: n }),
        s && /* @__PURE__ */ a("p", { className: i["switch-description"], children: s })
      ] }),
      /* @__PURE__ */ a(
        D,
        {
          className: i["switch-root"],
          id: e,
          checked: h,
          defaultChecked: u,
          onCheckedChange: t,
          value: o,
          name: r,
          "aria-label": r,
          disabled: c,
          children: /* @__PURE__ */ a(W, { className: i["switch-thumb"] })
        }
      )
    ]
  }
);
export {
  Y as Switch
};
